export const products = [
  {
    id: 1,
    name: "Complete Home Starter Kit",
    price: 64.00,
    description: "The definitive transition to zero-waste. Includes 3 frosted glass vessels (All-Purpose, Glass, Bathroom) and 6 initial refill pods.",
    image: "https://images.unsplash.com/photo-1610555356070-d1fb336fb482?auto=format&fit=crop&q=80&w=800",
    badge: "Most Popular",
    category: "Starter Kits",
    impact: "Saves 12 bottles/year",
    scents: ["Pacific Mist", "Cedar & Sage", "Unscented"]
  },
  {
    id: 2,
    name: "Foaming Hand Wash Set",
    price: 32.00,
    description: "Elevate your sink with our weighted glass pump. Includes our signature 'Pacific Mist' foaming concentrate pod.",
    image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?auto=format&fit=crop&q=80&w=800",
    category: "Personal Care",
    impact: "Saves 8 bottles/year",
    scents: ["Lemon Verbena", "Lavender Bloom"]
  },
  {
    id: 3,
    name: "Solid Dish Soap Block",
    price: 18.00,
    description: "Cold-pressed lemon and eucalyptus oil block. Cuts grease without synthetic surfactants. Lasts roughly 4-6 months.",
    image: "https://images.unsplash.com/photo-1605265002939-556157077aee?auto=format&fit=crop&q=80&w=800",
    badge: "Eco-Hero",
    category: "Kitchen",
    impact: "100% Biodegradable",
    scents: ["Lemon Eucalyptus"]
  },
  {
    id: 4,
    name: "Laundry Refill Bundle",
    price: 45.00,
    description: "90 loads of plant-based cleaning. Zero plastic, zero mess, zero heavy water weight. Just clean clothes.",
    image: "https://images.unsplash.com/photo-1584820927498-cafe4c10a40f?auto=format&fit=crop&q=80&w=800",
    category: "Laundry",
    impact: "Saves 4kg Plastic/year",
    scents: ["Fresh Linen", "Unscented"]
  }
];

export const reviews = [
  {
    id: 1,
    text: "The aesthetic of the glass bottles is what drew me in, but the cleaning power is what kept me. My counters have never been cleaner.",
    author: "Julianne M.",
    location: "Portland, OR",
    verified: true
  },
  {
    id: 2,
    text: "Swapping to the laundry sheets was the easiest sustainable switch I've made. No more giant plastic jugs taking up space.",
    author: "David K.",
    location: "Austin, TX",
    verified: true
  },
  {
    id: 3,
    text: "The subscription model is seamless. I love that the refills arrive in tiny paper envelopes that I can just toss in my compost.",
    author: "Sienna W.",
    location: "Brooklyn, NY",
    verified: true
  }
];

export const faqs = [
  {
    q: "How do I manage my refill schedule?",
    a: "Within your workspace, you can pause, skip, or accelerate your deliveries with a single click. We recommend a 2-month cycle."
  },
  {
    q: "Are the formulas truly non-toxic?",
    a: "Absolutely. We use plant-derived surfactants and essential oils. No parabens, no phthalates, and no VOCs."
  }
];